import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { QMTableData, QMTableOptions, QmAutocompleteData, QmCheckboxData, QmOrderlistData, QmPicklistData, QmRadiobuttonData } from '@md2/md2-component-lib';
import { QmSelectData } from '@md2/md2-component-lib/lib/qm-select/qm-select-data';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AuthService } from 'src/app/auth/auth.service';
import { LicenciadorService } from 'src/app/licenciamento/service/licenciador.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  providers: [ConfirmationService, MessageService]
})
export class HomeComponent implements OnInit {

  listaPessoas!: QmSelectData[];
  listaOptions!: QmRadiobuttonData[];
  listaCheckOptions!: QmCheckboxData[];
  listaAutoComplete!: QmAutocompleteData[];
  listaSuggestions: QmAutocompleteData[] = [];
  claims: any;

  tableData!: QMTableData<any>;
  tableData2!: QMTableData<any>;
  tableOptions!: QMTableOptions;

  sourceList!: QmPicklistData[];
  targetList: QmPicklistData[] = [];
  sourceOrderList!: QmOrderlistData[];

  myText: string = "";
  showDialog: boolean = false;

  access_token!: string;
  refresh_token!: string;
  id_token!: string;

  /*: ChatUserData = {
    username: "Chat GPT",
    avatar: "/assets/img/chat-gpt.png",
    online: true
  }*/

  constructor(
    private confirmService: ConfirmationService,
    private messageService: MessageService,
    private licenciadorService: LicenciadorService,
    private authService: AuthService,
    private router: Router,
  ) {


  }

  ngOnInit(): void {
    if (this.authService.isNaoLicenciado) {
      this.router.navigate(['licenciamento']);
    }
    this.validarLicenca();
  }

  validarLicenca(): void {
    this.licenciadorService.validarValidade().subscribe({
      error: () => this.messageService.add({ severity: 'error', summary: 'Falha', detail: "Falha na validação da chave de licenciamento!" }),
      next: (data) => {
        //this.messageService.add({severity:'warning', summary:'Validade próxima', detail: "A validade da chave de licenciamento está próxima do fim!"});
        if (data != null) {
          this.messageService.add({ severity: 'warn', summary: 'Validade próxima', detail: "A validade da chave de licenciamento está próxima do fim!" });
        }
      }
    })
  }

  onChangeValue(event: any) {
    console.log(event);
  }

  showDialogEvent() {
    this.showDialog = true;
  }

  hideDialogEvent() {
    this.showDialog = false;
  }

  onSearchData(event: any): void {
    this.listaSuggestions = this.listaAutoComplete.filter(el => el.label?.trim().toLowerCase().indexOf(event.query?.trim().toLowerCase()) !== -1);
  }

  confirm() {
    this.confirmService.confirm({
      key: 'qm-dialog',
      message: "Deseja sair? Informações que não foram salvas serão perdidas",
      accept: () => {
        console.log('Você aceitou');
      },
      reject: () => {
        console.log('Você rejeitou');
      }
    })
  }

  confirmPopup(event: Event) {
    this.confirmService.confirm({
      key: 'qm-popup',
      target: event.target as EventTarget,
      icon: 'pi pi-exclamation-triangle',
      message: "Deseja apagar os registros? Esta operação é irreversível",
      accept: () => {
        console.log('Você aceitou');
      },
      reject: () => {
        console.log('Você rejeitou');
      }
    })
  }

  confirmSucesso() {
    this.messageService.add({ severity: 'success', summary: 'Service Message', detail: 'Via MessageService', sticky: true });
  }

  confirmInfo() {
    this.messageService.add({ severity: 'info', summary: 'Service Message', detail: 'Via MessageService', sticky: true });
  }

  confirmAviso() {
    this.messageService.add({ severity: 'warn', summary: 'Service Message', detail: 'Via MessageService', sticky: true });
  }

  confirmFalha() {
    this.messageService.add({ severity: 'error', summary: 'Service Message', detail: 'Via MessageService', sticky: true });
  }


}




